import { use } from "react"

import { AppContext } from "./app-context"

export const useAppContext = () => {
  const context = use(AppContext)
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppProvider")
  }
  return context
}
